import { User } from 'src/types/user.types';
import { reportError } from 'src/modules/logs/Sentry';
import { Intercom } from '@capacitor-community/intercom';
import { getModuleExternalId } from 'src/utils/external-id';
import type { SupportSource } from 'src/modules/support/support.types';

export const initIntercomSupport = async () => {};

export const initUserToIntercomSupport = async (user?: User) => {
  if (!user) {
    try {
      await Intercom.logout();
    } catch (error) {
      reportError('Error while logging out from Intercom', error);
    }
    return;
  }

  try {
    await Intercom.registerIdentifiedUser({
      userId: getModuleExternalId(user.id),
      email: user.email,
    });
    await Intercom.updateUser({
      name: user.firstname,
      customAttributes: {
        family_id: user.family_id,
        user_type: user.user_type,
      },
    });
  } catch (error) {
    reportError('Error while init user in Intercom', error);
  }
};

const tagSupportSource = async (source: SupportSource) => {
  await Promise.allSettled([
    Intercom.logEvent({ name: 'support_opened', data: { source } }),
    Intercom.updateUser({
      customAttributes: { last_support_source: source },
    }),
  ]);
};

export const openIntercomMessenger = async (source: SupportSource) => {
  // Deliberately not awaited: tagging is bookkeeping and must never sit between the tap and the
  // messenger.
  void tagSupportSource(source);

  try {
    await Intercom.displayMessenger();
  } catch (error) {
    reportError('Error while opening Intercom', error);
  }
};
